<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" :class="design" :width="width" :height="height">
        <path
            :fill="fill"
            d="M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 128zm0 
            192c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 320z" />
    </svg>
</template>
<script>
export default {
    name: 'ui-equals-icon',
    props: {
        fill: {
            type: String,
            default: '#2d93f8'
        },
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 8
        },
        height: {
            type: [String, Number],
            default: 8
        }
    }
}
</script>